<!-- PROGRESS BAR -->
<app-progress-bar></app-progress-bar>
<!-- / PROGRESS BAR -->

<!-- <app-layout></app-layout> -->
<router-outlet></router-outlet>